/**
 * Supplier Info status constants
 * These are used across the application to maintain consistency in status values
 */

const SUPPLIER_INFO_STATUS = {
	DRAFT: "DRAFT",
	FINALIZED: "FINALIZED",
	ARCHIVED: "ARCHIVED",
};

export default SUPPLIER_INFO_STATUS;
